/* import __COLOCATED_TEMPLATE__ from './environment-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';
import type Environment from 'embercom/models/standalone/environment';

interface Signature {
  Args: {
    environment: Environment;
    isOn: boolean;
    onClick: () => void;
  };
}

const EnvironmentToggle = templateOnlyComponent<Signature>();
export default EnvironmentToggle;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::StandaloneCommon::EnvironmentToggle': typeof EnvironmentToggle;
  }
}
